var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.34 36.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f29f39;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hand-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.75,25.21a3,3,0,0,0,3,3l22.13-.07a3,3,0,0,0,3-3l0-13.74-28.13.09ZM29,19.73a1.38,1.38,0,0,1,0-1.38l.34-.59L26,16.1h0a.69.69,0,0,1-.6.35H24.5a.69.69,0,0,1-.6-.35l-.47-.81a.69.69,0,0,1,0-.69l.47-.81a.69.69,0,0,1,.6-.35h.93a.69.69,0,0,1,.6.35l.47.81a.69.69,0,0,1,0,.69l-.11.19,3.34,1.65.1-.18a1.38,1.38,0,0,1,1.2-.69h1.59a1.39,1.39,0,0,1,1.2.69l.79,1.37a1.38,1.38,0,0,1,0,1.38l-.82,1.37a1.38,1.38,0,0,1-1.2.69H31a1.38,1.38,0,0,1-1.2-.69L29.76,21,26.4,23.44l.08.14a.69.69,0,0,1,0,.69l-.47.81a.69.69,0,0,1-.6.35h-.93a.69.69,0,0,1-.6-.35l-.47-.81a.69.69,0,0,1,0-.69l.47-.81a.69.69,0,0,1,.6-.35h.93a.69.69,0,0,1,.6.35v.07l3.36-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.44,20.73a.69.69,0,0,0,.6.35h1.58a.69.69,0,0,0,.6-.35L34,19.34a.69.69,0,0,0,0-.69l-.79-1.37a.69.69,0,0,0-.6-.35H31a.69.69,0,0,0-.6.35l-.79,1.37a.69.69,0,0,0,0,.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.48 14.13 24.01 14.93 24.48 15.74 25.41 15.73 25.88 14.92 25.41 14.12 24.48 14.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.7,7.64l-21.9.07a3.79,3.79,0,0,0-3.42,2.17l28.76-.1A3.79,3.79,0,0,0,38.7,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.84,36.1a11.91,11.91,0,0,0,1.69.12l22.85-.08a12,12,0,0,0,12-12h0L47.3,12a12,12,0,0,0-12-12L12.41.08a11.91,11.91,0,0,0-1.69.15Zm6-29.64,21.9-.07a5,5,0,0,1,5.07,5h-.67l0,13.74a4.26,4.26,0,0,1-4.25,4.27l-22.14.07a4.26,4.26,0,0,1-4.27-4.25h0l0-13.74h-.67a5,5,0,0,1,5-5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.51 23.13 24.04 23.93 24.51 24.74 25.44 24.73 25.91 23.92 25.44 23.12 24.51 23.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 18.19 10.84 36.23 10.72 0.08 0 18.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.49,
    y: 4.51,
    width: 34,
    height: 27.33,
    transform: "translate(53.04 36.27) rotate(179.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.64,
    y: 8.71,
    width: 4,
    height: 8.2,
    transform: "translate(85.32 25.47) rotate(179.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.29,9.55a1.43,1.43,0,0,0-1.46,1.39l-.12,4.89a.48.48,0,1,1-.95,0L32,8a1.43,1.43,0,0,0-2.85-.07l-.16,6.83a.48.48,0,1,1-.95,0l.18-7.8a1.43,1.43,0,1,0-2.85-.07l-.18,7.8a.48.48,0,1,1-.95,0l.14-5.86a1.43,1.43,0,1,0-2.85-.07l-.17,7.41a1.06,1.06,0,0,1-1.94.57,1.75,1.75,0,1,0-3.07,1.67c0,.1.11.19.16.28l4.18,6.82C21.91,27.57,24,29.23,28,29.32c6.63.16,7.35-5.07,7.39-6.63L35.68,11A1.42,1.42,0,0,0,34.29,9.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandOn);
export default __webpack_public_path__ + "static/media/hand-on.fc31fe91.svg";
export { ForwardRef as ReactComponent };